var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4318ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.672 1.911a1 1 0 1 0-1.932.518l.259.966a1 1 0 1 0 1.931-.518zM2.429 4.74a1 1 0 0 0-.518 1.932l.966.258A1 1 0 1 0 3.395 5zM11.242 4.171a1 1 0 1 0-1.414-1.414l-.707.707a1 1 0 1 0 1.414 1.414zM4.171 11.242l.707-.707a1 1 0 1 0-1.414-1.414l-.707.707a1 1 0 1 0 1.414 1.414zM7.371 6.071a1 1 0 0 0-1.3 1.3l4 10a1 1 0 0 0 1.823.076l1.38-2.759 3.019 3.019a1 1 0 0 0 1.414-1.414l-3.019-3.02 2.76-1.379a1 1 0 0 0-.077-1.823z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.ea6d326f35c6872efd4a1e878e6751bc.svg";
export { ForwardRef as ReactComponent };